// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCmdAdP1YYMgIBsG733wxyynFvHxXAgyC8",
    authDomain: "photogal-68400.firebaseapp.com",
    projectId: "photogal-68400",
    storageBucket: "photogal-68400.appspot.com",
    messagingSenderId: "676264038612",
    appId: "1:676264038612:web:95c4671f3773c322742b41"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;